import { AbstractControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { BaseInput } from './base-input';
import { NopInput } from './nop-input';

export const hasRequiredField = (abstractControl: AbstractControl): boolean => {
	if (abstractControl.validator) {
		const validator = abstractControl.validator({} as AbstractControl);
		if (validator && validator.required) {
			return true;
		}
	}
	if (abstractControl['controls']) {
		for (const controlName in abstractControl['controls']) {
			if (abstractControl['controls'][controlName]) {
				if (
					hasRequiredField(abstractControl['controls'][controlName])
				) {
					return true;
				}
			}
		}
	}
	return false;
};

export interface FieldsetInputConstructor {
	label: string;
	required?: boolean;
	showBottomBorder?: boolean;
	controls: {
		[key: string]: BaseInput | FieldsetInput;
	};
}

export class FieldsetInput extends UntypedFormGroup {
	inputType = 'fieldset';
	label: string;
	showBottomBorder = false;
	controlsArray = [];
	index: number;
	required?: boolean;
	private subscription: Subscription;

	controls: {
		[key: string]: BaseInput;
	};

	constructor(options: FieldsetInputConstructor) {
		super(options.controls);

		if (options.required) {
			this.required = options.required;
		}

		if (options.showBottomBorder) {
			this.showBottomBorder = options.showBottomBorder;
		}

		this.label = options.label;

		this._initChildControls();
	}

	setIndex(index: number): void {
		(this as { index: number }).index = index;
		this._setFieldsetControlsIndex(this.controls);
	}

	private _setFieldsetControlsIndex(controls: {
		[key: string]: BaseInput;
	}): void {
		let i = this._findMaxIndex(controls) + 1;
		for (const name in controls) {
			if (controls[name]) {
				if (controls[name].index === undefined) {
					controls[name].setIndex(i);
					i++;
				}
			}
		}
	}

	private _findMaxIndex(controls: { [key: string]: BaseInput }): number {
		let i = 0;
		for (const name in controls) {
			if (
				controls[name] &&
				Number.isInteger(controls[name].index) &&
				controls[name].index > i
			) {
				i = controls[name].index;
			}
		}
		return i;
	}

	unsubscribeSubscriptions() {
		for (const name in this.controls) {
			if (this.controls[name]) {
				this.controls[name].unsubscribeSubscriptions();
			}
		}
		if (this.subscription instanceof Subscription) {
			this.subscription.unsubscribe();
		}
	}

	private _initChildControls() {
		const controls = this.controls;

		for (const controlName in controls) {
			if (controls[controlName].requiredToFieldset) {
				if (this.required) {
					const validator = [];
					if (controls[controlName].validator) {
						validator.push(controls[controlName].validator);
					}
					validator.push(Validators.required.bind(this));
					controls[controlName].setValidators(validator);
				} else {
					this.controlsArray.push(controlName);
				}
			}
		}
		if (this.controlsArray.length > 0) {
			this.subscription = this.valueChanges.subscribe((values) => {
				this._listenForInputsChanges(values);
			});
		}
	}

	private _listenForInputsChanges(values: any) {
		let shouldSetRequired = false;
		for (const name in values) {
			if (values[name]) {
				shouldSetRequired = true;
				break;
			}
		}
		// se shouldSetRequired è false allora se gli input hanno i validator, vanno tolti
		// se shouldSetRequired è true allora se gli input non hanno i validator, vanno messi

		this.controlsArray.forEach((controlName) => {
			if (shouldSetRequired) {
				if (
					!hasRequiredField(this.controls[controlName]) &&
					!(this.controls[controlName] instanceof NopInput)
				) {
					const validator = [];
					if (this.controls[controlName].validator) {
						validator.push(this.controls[controlName].validator);
					}
					validator.push(Validators.required.bind(this));
					this.controls[controlName].setValidators(validator);
					this.controls[controlName].updateValueAndValidity();
				}
			} else {
				this.controls[controlName].clearValidators();
				if (this.controls[controlName].pattern) {
					const pattern = this.controls[controlName].pattern;
					this.controls[controlName].setValidators(
						Validators.pattern(pattern)
					);
				}
			}
		});
	}
}
